import axios from "axios";
import React, { useEffect, useState } from "react";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';

const Testimonial = () => {
    const backendBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL;
    const [testimonials, setTestimonials] = useState([]);
    const cacheExpiryTime = 30 * 60 * 1000; // 30 minutes in milliseconds

    useEffect(() => {
        // Check if testimonials data is available in localStorage
        const cachedData = JSON.parse(localStorage.getItem('testimonialsData'));

        if (cachedData) {
            const { data, timestamp } = cachedData;

            // Check if the cached data has expired (older than 30 minutes)
            const currentTime = Date.now();
            if (currentTime - timestamp < cacheExpiryTime) {
                // If not expired, use the cached data
                setTestimonials(data);
            } else {
                // If expired, clear the cache and fetch new data
                localStorage.removeItem('testimonialsData');
                fetchTestimonials();
            }
        } else {
            // If no cache, fetch data from the API
            fetchTestimonials();
        }
    }, []);

    const fetchTestimonials = async () => {
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const Url = process.env.REACT_APP_API_TESTIMONIAL;
        try {
            const response = await axios.get(`${apiBaseUrl}${Url}`);
            const newData = response.data;

            // Save the fetched data along with the current timestamp in localStorage
            localStorage.setItem('testimonialsData', JSON.stringify({
                data: newData,
                timestamp: Date.now(),
            }));
            setTestimonials(newData);
        } catch (error) {
            console.error('Failed to fetch Testimonials:', error);
        }
    };

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        fade: false,
        slidesToShow: 2,        // Show two slides at a time by default
        slidesToScroll: 1,      // Scroll one slide at a time by default
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
        prevArrow: <button className="custom-prev">Prev</button>,
        nextArrow: <button className="custom-next">Next</button>,
        centerMode: false,
        responsive: [
            {
                breakpoint: 768, // Below 768px (typically tablets and mobile devices)
                settings: {
                    slidesToShow: 1,        // Show only one slide at a time
                    slidesToScroll: 1,      // Scroll one slide at a time
                },
            },
            {
                breakpoint: 1024, // For devices like tablets
                settings: {
                    slidesToShow: 2,        // Show two slides at a time
                    slidesToScroll: 2,      // Scroll two slides at a time
                },
            },
        ],
    };

    return (
        <section className="testimonail-area grey-bg pt-80 pb-80">
            <div className="container px-1">
                <div className="row justify-content-center">
                    <div className="col-xxl-10">
                        <div className="section_title_wrapper text-center mb-50">
                            <h1 className={'text-center fw-bold text-uppercase'}>
                                What clients say about us ?
                            </h1>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="testimonial-slider">
                        <Slider {...settings}>
                            {testimonials.map((testimonial, index) => (
                                <div className="testimonail__wrapper rounded-5" key={index}>
                                    <div className="testimonail__wrapper__info d-flex align-items-center mb-25">
                                        <div className="testimonail__wrapper__info__img">
                                            <img className={'rounded-circle'} width={70} src={`${backendBaseUrl}${testimonial?.image}`} alt={testimonial?.name} />
                                        </div>
                                        <div className="testimonail__wrapper__info__author">
                                            <h4>{testimonial?.name}</h4>
                                        </div>
                                        <div className="testimonail__wrapper__info__quotes">
                                            <i className="flaticon-quote"></i>
                                        </div>
                                    </div>
                                    <div className="testimonail__wrapper__content">
                                        <p>{testimonial?.message}</p>
                                        <div className="testimonail__wrapper__content__reviews">
                                            <ul>
                                                {Array.from({ length: 5 }, (_, index) => {
                                                    const starValue = index + 1;
                                                    if (testimonial?.rating >= starValue) {
                                                        return <i key={starValue} className="fas fa-star filled text-warning" />;
                                                    } else if (testimonial?.rating >= starValue - 0.5) {
                                                        return <i key={starValue} className="fas fa-star-half-alt filled text-danger" />;
                                                    } else {
                                                        return <i key={starValue} className="fas fa-star" />;
                                                    }
                                                })}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Testimonial;
